/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { OasResponse } from '../../models/OasResponse';
import { OasResponses } from '../../models/OasResponses';

/**
 * Constructor.
 * @class
 * @extends OasResponses
 * @author eric.wittmann@gmail.com
 */
export class Oas20Responses extends OasResponses {
    public constructor() {
        super();
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasResponses#createResponse(java.lang.String)
     * @param {string} statusCode
     * @return {OasResponse}
     */
    public createResponse(statusCode : string) : OasResponse {
        let response : OasResponse = new Oas20Response(statusCode);
        response._ownerDocument = this.ownerDocument();
        response._parent = this;
        return response;
    }
}
Oas20Responses["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Responses";
Oas20Responses["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IIndexedNode"];





import { Oas20Response } from './Oas20Response';

